import { useEffect, useRef } from "react";
import type { ILocalVideoTrack, IRemoteVideoTrack } from "agora-rtc-react";
import { meetVideoPlayerConfig } from "../../videoFrameStyles";

type AgoraVideoTrack = ILocalVideoTrack | IRemoteVideoTrack;

interface MeetStyleVideoPlayerProps {
  track: AgoraVideoTrack | null | undefined;
  play?: boolean;
  style?: React.CSSProperties;
}

export const MeetStyleVideoPlayer = ({
  track,
  play = true,
  style,
}: MeetStyleVideoPlayerProps) => {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!track) {
      return;
    }

    if (!play) {
      track.stop();
      return;
    }

    const container = containerRef.current;
    if (!container) {
      return;
    }

    track.play(container, meetVideoPlayerConfig);

    return () => {
      track.stop();
    };
  }, [track, play]);

  return (
    <div
      ref={containerRef}
      style={{
        width: "100%",
        height: "100%",
        backgroundColor: "#202124",
        ...style,
      }}
    />
  );
};

export default MeetStyleVideoPlayer;
